import React from "react";
const TrashIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    ...props
  },
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "trash-icon-path",
      d: "M15 5v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5h-.8a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2h12.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H15zm-1 0H5v10.8c0 .11.09.2.2.2h8.6a.2.2 0 0 0 .2-.2V5zM7.2 7h.6c.11 0 .2.09.2.2v6.6a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2zm4 0h.6c.11 0 .2.09.2.2v6.6a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2zM6.857 3v1H6V3a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1h-.857V3H6.857z"
    }
  )),
  /* @__PURE__ */ React.createElement("g", { fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("mask", { id: "trash-icon-mask" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#trash-icon-path" })), /* @__PURE__ */ React.createElement("use", { xlinkHref: "#trash-icon-path" }))
);
var TrashIcon_default = TrashIcon;
export {
  TrashIcon_default as default
};
//# sourceMappingURL=TrashIcon.js.map
